module.exports = __webpack_public_path__ + "static/vorwort_hb8-bc3e3f7578420f158523fbfab89a1123.pdf";